import React from 'react'
import {appApi} from '../../services';
import {Spin} from 'antd'
import { ekincare_full_logo} from '../../assets/images'
import {Redirect} from 'react-router-dom'
import {LeftPanel, ForgotPassword} from '../common/templates/Login';

class ForgotPasswordPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isLoading: false,
      window_height: window.innerHeight,
      show_password:false,
      username:'',
      error_msg:'',
      forgot_request:false,
    }
  }

  enterHandler = (event) => {
    if(event.key === 'Enter') {
      this.handleForgot();
    }
  }

  componentDidMount() {
    this.updateDimensions()
    window.addEventListener('keypress', this.enterHandler)
    window.addEventListener('resize', this.updateDimensions.bind(this))
  }

  componentWillMount() {
    sessionStorage.setItem('defaultSelectedTab', '9')
    window.removeEventListener('keypress', this.enterHandler)
    window.removeEventListener('resize', this.updateDimensions.bind(this))
  }

  updateDimensions() {
    this.setState({window_height: window.innerHeight})
  }

  handleForgot = async () => {
    const {username} = this.state;

    if(username) {
      this.setState({isLoading: true});
      const options = {
        data:{email:username}
      }
      let error_msg = '', forgot_request = false;
      
      try {
        await appApi.forgot(options);
        forgot_request = true;
      } catch(err) {
        forgot_request = true;
      }

      this.setState({error_msg, forgot_request, isLoading:false});
    }
  }

  setfield = (event) => {
    const value = event.target.value;
    
    this.setState({username:value, error_msg: value ? "":"Please input your username!"});
  }

  render() {
    let {redirect, isLoading} = this.state
    const {history} = this.props;
    if (redirect) {
      return <Redirect to="/" />
    }

    if (isLoading) {
      return (
        <div className="spiner">
          <Spin size="large" />
        </div>
      )
    }

    return (
      <div className='flex min-h-screen'>
        <LeftPanel />
        
        <div className='w-2/5 pt-16 pl-24 bg-white'>
          <img src={ekincare_full_logo} alt='ekincare_logo' />
          <ForgotPassword {...this.state} setfield={this.setfield} handleForgot={this.handleForgot} history={history} />
        </div> 
      </div>
    )
  }
}

export default ForgotPasswordPage;
